var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step-inner-content" },
      [
        _c("SelectWrapper", {
          attrs: {
            item: "Subscription",
            caption: "Create your own SVOD platform",
          },
          model: {
            value: _vm.Global.mockupConfig.business.subscription,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.business, "subscription", $$v)
            },
            expression: "Global.mockupConfig.business.subscription",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          attrs: {
            item: "Transactional",
            caption: "Build your video rental shop",
          },
          model: {
            value: _vm.Global.mockupConfig.business.transactional,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.business, "transactional", $$v)
            },
            expression: "Global.mockupConfig.business.transactional",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          attrs: {
            item: "Pay per View",
            caption: "Open access to your platform for events",
          },
          model: {
            value: _vm.Global.mockupConfig.business.payPerView,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.business, "payPerView", $$v)
            },
            expression: "Global.mockupConfig.business.payPerView",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          attrs: {
            item: "Advertising",
            caption: "Monetize your content through ads",
          },
          model: {
            value: _vm.Global.mockupConfig.business.advertising,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.business, "advertising", $$v)
            },
            expression: "Global.mockupConfig.business.advertising",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          attrs: { item: "Free", caption: "Provide free content to end users" },
          model: {
            value: _vm.Global.mockupConfig.business.free,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.business, "free", $$v)
            },
            expression: "Global.mockupConfig.business.free",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nxt-out" },
          [
            _c("div", { staticClass: "bgout" }),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "btn bck", attrs: { tag: "div", to: "/content" } },
              [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "btn main txt-blk",
                attrs: { tag: "div", to: "/look" },
              },
              [
                _c("span", { staticClass: "hvr" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro-block" }, [
      _c("h5", { staticClass: "txt-grt" }, [_vm._v("Business models")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Define your business models. You can pick and choose the best monetization for your community."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }